export const SET_LOADING = "SET_LOADING";
export const GET_CONTACT = "SET_LOADING";
export const FILTER_CONTACTS = "FILTER_CONTACTS";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const ADD_CONTACT = "ADD_CONTACT";
export const SET_PAGE = "SET_PAGE";
